import { React, useEffect, useState } from "react";
import Quotes from "../assets/quotes.png";

const About = ({ screenInfo }) => {
  const [Swidth, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const { isDesktopModeOnMobile, width } = screenInfo;

  useEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // const [isDesktopSiteOnMobile, setIsDesktopSiteOnMobile] = useState(false);

  // useEffect(() => {
  //   const checkDesktopSiteMode = () => {
  //     const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  //     const isDesktopWidth = window.innerWidth > 800; // Adjust threshold if needed
  //     setIsDesktopSiteOnMobile(isMobile && isDesktopWidth);
  //   };

  //   checkDesktopSiteMode();
  //   window.addEventListener("resize", checkDesktopSiteMode);
  //   return () => window.removeEventListener("resize", checkDesktopSiteMode);
  // }, []);

  return (
    <div
      className={`${
        isDesktopModeOnMobile && width > 768 
          ? ""
          : "lg:min-h-screen  "
      }  w-full  flex justify-center 2xl:items-center lg:pt-[8rem] pt-[6rem] sm:py-[8rem]    px-4 sm:px-6 md:px-6 max-sm:pb-0 pb-10 lg:pb-[4.5rem]   `}
    >
      <div className="flex flex-col gap-6 sm:gap-8 md:gap-[6rem] text-white w-full max-w-screen-md md:max-w-[90vw] lg:max-w-[80vw] xl:max-w-[80vw] 2xl:max-w-[70vw]">
        {/* Heading Section */}
        <div className="flex flex-col gap-4 sm:gap-6 items-center text-center">
          <h1 className="poppins-semibold text-2xl sm:text-3xl md:text-4xl">
            Who We Are
          </h1>
          {/* <p className="text-sm">Width: {Swidth}px</p>
          <p className="text-sm">Height: {height}px</p>
          <p className="text-lg font-semibold">
            Desktop Site Mode:{" "}
            <span
              className={
                isDesktopModeOnMobile ? "text-green-400" : "text-red-400"
              }
            >
              {isDesktopModeOnMobile ? "ON" : "OFF"}
            </span>
          </p> */}
          <p className="poppins-regular text-sm text-center sm:text-base md:text-lg md:text-left leading-[1.8rem] sm:leading-[1.8rem] md:leading-[2rem]  lg:leading-[2.2rem] tracking-wide opacity-90 px-2 sm:px-4">
            At Optimum Codes, we are more than just a tech company – we are
            problem solvers, innovators, and digital enablers. Our mission is to
            help businesses embrace the digital era with seamless, scalable, and
            smart technology solutions.
            <br />
            <br />
            Beyond business, we are also committed to shaping the next
            generation of tech professionals. By providing hands-on experience
            with real-world projects, we help aspiring developers build the
            skills and confidence needed to excel in the ever-evolving tech
            industry.
          </p>
        </div>

        {/* Quote Section */}
        <div className="flex flex-col items-center gap-3 sm:gap-4 text-center">
          <img
            src={Quotes}
            alt="Quotes"
            className="w-8 h-6 sm:w-10 sm:h-8 md:w-12 md:h-10"
          />
          <p className="poppins-semibold text-base sm:text-xl md:text-2xl leading-relaxed opacity-90">
            At Optimum Codes, we don’t just build software
          </p>
          <h2 className="poppins-bold bg-gradient-to-r from-[#C895F1] to-[#7B2187] text-transparent bg-clip-text text-xl sm:text-2xl md:text-4xl">
            We Build the Future
          </h2>
        </div>
      </div>
    </div>
  );
};

export default About;
